var React = require('react');

function Website (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M20.599 39.5H9.602v-3.323h10.997M16.047 36.074v-4.243H.6V5.5h20M20.6 39.5h10.997v-3.323H20.6M25.152 36.074v-4.243H40.6V5.5h-20","stroke":"#D22128","strokeMiterlimit":"10","key":0}),React.createElement("path",{"d":"M4.271 28.416V8.813H36.98v19.605H4.27Z","stroke":"#D22128","key":1}),React.createElement("path",{"d":"m16.559 21.86-5.729-3.22 5.729-3.272M24.743 21.86l5.78-3.22-5.78-3.272M18.605 24.775l3.938-12.321","stroke":"#D22128","strokeMiterlimit":"10","key":2})]);
}

Website.defaultProps = {"width":"42","height":"40","fill":"none"};

module.exports = Website;

Website.default = Website;
